










































































import {Component, Vue, Prop} from 'vue-property-decorator';
import {Address} from "../model";

export class FormErrors {
  genderErrorMessage!: string;
  zipErrorMessage!: string;
}

@Component({})
export default class AddressForm extends Vue {
  @Prop({default: null}) value!:Address;
  formErrors: FormErrors = new FormErrors();
  valid: boolean = false;

  private validateGender(): boolean {
    let valid = true;
    let formErrors = new FormErrors();

    if (!this.value.gender) {
      // noinspection TypeScriptUnresolvedVariable
      formErrors.genderErrorMessage = "Bitte wähle eine Anrede aus!";
      valid = false;
    }

    this.formErrors = formErrors;
    return valid;

  }

  private validateZIP(): boolean {
    let valid = true;
    let formErrors = new FormErrors();
    let plzRegEx = new RegExp(/[0-9]{5}/);

    if (!plzRegEx.test(this.value.zip)) {
      // noinspection TypeScriptUnresolvedVariable
      formErrors.zipErrorMessage = "Gib bitte eine korrekte PLZ an";
      valid = false
    }
    this.formErrors = formErrors;
    return valid;
  }

  validateAddress() {
    this.valid = this.validateGender() && this.validateZIP()
  }

}
